/**
 * #4102 — o contato recebido pelo socket casa o filtro que está na tela?
 *
 * O socket inseria na lista qualquer contato criado/atualizado na empresa,
 * mesmo com busca ou tag filtrando. Daí os "contatos sem nenhuma relação" no
 * resultado, e a sensação de duplicata quando a página seguinte trazia o mesmo
 * contato de novo.
 *
 * Espelha o critério do ListContactsService (backend): nome sem acento, número
 * só quando o termo tem 3+ dígitos, e tags em AND (todas).
 *
 * Em arquivo próprio (e não dentro de index.js) para poder ser testado — o
 * index puxa NewTicketModal -> PluginBridge e o Jest não resolve essa cadeia.
 */

const semAcento = (s) =>
  (s || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase();

export const matchesFilter = (contact, filter) => {
  if (!contact) return false;
  const { searchParam = "", selectedTags = [] } = filter || {};

  const termo = searchParam.trim().toLowerCase();
  if (termo) {
    const casaNome = semAcento(contact.name).includes(semAcento(termo));

    // O backend só busca por número quando sobram 3+ dígitos no termo
    // (numberSearchTerm) — menos que isso casaria quase todos.
    const digitos = termo.replace(/\D/g, "");
    const casaNumero =
      digitos.length >= 3 && (contact.number || "").includes(digitos);

    if (!casaNome && !casaNumero) return false;
  }

  if (selectedTags.length > 0) {
    const tagsDoContato = (contact.tags || []).map((t) => t.id);
    // AND real: precisa ter TODAS as tags selecionadas.
    const temTodas = selectedTags.every((id) => tagsDoContato.includes(id));
    if (!temTodas) return false;
  }

  return true;
};

export default matchesFilter;
